import type { TranslationMessages } from './types';

export const assistant: TranslationMessages = {
  title: 'Virtual Assistant',
  description: 'Ask me anything about your store operations',
  startConversation: 'Start a conversation with your assistant',
  helpMessage:
    'I can help you create orders, manage inventory, answer questions, and more!',
  inputPlaceholder: 'Type your message... (Press Enter to send)',
  captureScreenshot: 'Capture screenshot',
  clearHistory: 'Clear chat history',
  clearHistoryConfirm: 'Are you sure you want to clear chat history?',
  encryptHistory: 'Encrypt chat history (for public computers)',
  errorMessage:
    'Sorry, I encountered an error. Please try again or contact support.',
  approve: 'Approve',
  reject: 'Reject',
  suggestions: {
    createOrder: 'Create an order',
    createProduct: 'Create a product',
    viewInventory: 'View inventory',
    help: 'How can you help?',
  },
  orderItems: 'Order Items',
  customer: 'Customer',
};
